import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['input', 'output'];
	static values = { prefix: String };

	connect() {
		this.updateOutput();
	}

	updateOutput() {
		const value = parseInt(this.inputTarget.value, 10);
		const min = parseInt(this.inputTarget.min, 10);
		const max = parseInt(this.inputTarget.max, 10);
		const percentage = ((value - min) / (max - min)) * 100;

		this.outputTarget.textContent = `${this.prefixValue} ${this.formatNumber(value)}`;

		const outputEl = this.outputTarget;
		const sliderEl = this.inputTarget;

		outputEl.style.left = 'auto';
		outputEl.style.right = 'auto';
		outputEl.style.transform = 'translateX(-50%)';
		outputEl.style.left = `${percentage}%`;

		requestAnimationFrame(() => {
			const outputRect = outputEl.getBoundingClientRect();
			const sliderRect = sliderEl.getBoundingClientRect();

			const overflowLeft = outputRect.left < sliderRect.left;
			const overflowRight = outputRect.right > sliderRect.right;

			if (overflowLeft) {
				outputEl.style.left = '-1.1rem';
				outputEl.style.transform = 'translateX(0)';
			} else if (overflowRight) {
				outputEl.style.left = 'auto';
				outputEl.style.right = '-1.1rem';
				outputEl.style.transform = 'translateX(0)';
			}
		});
	}

	formatNumber(number) {
		return number.toLocaleString('cs-CZ').replace(/,/g, ' ');
	}
}
